import React from "react"
import tw from "twin.macro"
import { useRoutes } from "../../../hooks/useRoutes"
import { CartItem } from "../Item/CartItem"
import { withCartList } from "./withCartList"
import { StyledP } from "../../Styled/Text"
import { StyledButton } from "../../Styled/Button"
import { Link } from "gatsby"
const CartItemList = tw.div`justify-start pl-1 md:pl-0`
const EmptyList = tw.div`w-full m-auto mt-2-4 text-center`

const P = tw(StyledP)`mb-4-8`
const ButtonWrap = tw.div`block mb-4 w-full text-center`
const Button = tw(StyledButton)`uppercase cursor-pointer bg-lightest`

export const CartList = withCartList(
  ({ checkout, count, emptyText, cartButtons }): JSX.Element => (
    <>
      {count > 0 ? (
        <CartItemList>
          {checkout?.lineItems?.map(item => (
            <CartItem key={item?.id} item={item} />
          ))}
        </CartItemList>
      ) : (
        <EmptyList>
          <P>{emptyText ? emptyText : "Your cart is empty"}</P>
          {cartButtons &&
            cartButtons.map((cartButton, index) => {
              const { linkResolver } = useRoutes()
              const link = linkResolver(cartButton?.buttonLink?._rawDocument)
              return (
                <ButtonWrap key={index}>
                  <Button
                    as={link.url ? Link : null}
                    to={link.url}
                    className={`primary_button`}
                    colour={`transparent`}
                    layout={`primary`}
                    background={`light`}
                    textsize={`primary-md`}
                  >
                    {cartButton.buttonText}
                  </Button>
                </ButtonWrap>
              )
            })}
        </EmptyList>
      )}
    </>
  )
)
